import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { Inicio } from "../../components/Home/Home";
import { useTranslation } from "react-i18next";

const Home = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("aux.home"),
					component: <Inicio />,
				}}
				right={null}
			/>
		</>
	);
};

export { Home };
